import Component from '../inherited/Component'
import Konva from 'konva';

export default class KonvaColourChange extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._stageElem = this._elem.querySelector('[data-konva-colour-change-stage]')
    this._renderElems = document.querySelectorAll('[data-konva-colour-change-render]')
    this._selectedSwatchElems = document.querySelectorAll('[data-konva-colour-change-selected-swatch]')
    this._selectedTitleElems = document.querySelectorAll('[data-konva-colour-change-selected-title]')
    this._properties = document.querySelectorAll('[data-konva-colour-change-property]')
  }

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  getCrop(image, size) {
    const width = size.width;
    const height = size.height;
    const aspectRatio = width / height;

    let newWidth;
    let newHeight;

    const imageRatio = image.width / image.height;

    if (aspectRatio >= imageRatio) {
      newWidth = image.width;
      newHeight = image.width / aspectRatio;
    } else {
      newWidth = image.height * aspectRatio;
      newHeight = image.height;
    }

    let x = (image.width - newWidth) / 2;
    let y = (image.height - newHeight) / 2;

    return {
      cropX: x,
      cropY: y,
      cropWidth: newWidth,
      cropHeight: newHeight,
    };
  }

  applyCrop (layer, selector) {
    const img = layer.findOne(selector);
    const crop = this.getCrop(
      img.image(),
      { width: img.width(), height: img.height() }
    );
    img.setAttrs(crop);
  }

  async mount () {
    let stage = new Konva.Stage({
      container: this._stageElem,
      width: this._stageElem.clientWidth,
      height: this._stageElem.clientHeight
    });

    window.addEventListener('resize', e => {
      stage.setAttrs({
        width: this._stageElem.clientWidth,
        height: this._stageElem.clientHeight
      });
    }, { passive: true })

    let layer = new Konva.Layer();
    stage.add(layer);

    Konva.Image.fromURL(this._options.mainImage, (image) => {
      console.log(image)

      image.setAttrs({
        width: this._stageElem.clientWidth,
        height: this._stageElem.clientHeight,
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
        name: 'image'
      });
      layer.add(image);

      window.addEventListener('resize', e => {
        image.setAttrs({
          width: this._stageElem.clientWidth,
          height: this._stageElem.clientHeight
        });
        this.applyCrop(layer, '.image');
      }, { passive: true })

      this.applyCrop(layer, '.image');

      Konva.Image.fromURL(this._options.subImage, (image) => {
        image.setAttrs({
          x: 0,
          y: 0,
          width: this._stageElem.clientWidth,
          height: this._stageElem.clientHeight,
          scaleX: 1,
          scaleY: 1,
          name: 'sub'
        }); 
        image.cache();
        image.filters([Konva.Filters.RGB, Konva.Filters.HSL, Konva.Filters.Contrast]);
        layer.add(image);

        window.addEventListener('resize', e => {
          image.setAttrs({
            width: this._stageElem.clientWidth,
            height: this._stageElem.clientHeight
          });
          image.cache();
          this.applyCrop(layer, '.sub');
        }, { passive: true })

        this.applyCrop(layer, '.sub');

        // image.luminance(0.6);
        // image.contrast(50);

        this._colourImage = image

        this._elem.classList.add('rendered')

        for (let item of this._renderElems) {
          item.classList.add('rendered')
        }

        this._ctx.emit('konva--ready')
      })
    })

    this._ctx.on('konva-set-colour', (state, data) => {
      console.log(data)
      if (this._colourImage) {
        let rgb = this.hexToRgb(data.color)
        if (rgb?.r) {
          this._colourImage.red(parseFloat(rgb.r))
          this._colourImage.green(parseFloat(rgb.g))
          this._colourImage.blue(parseFloat(rgb.b))
        }

        for (let item of this._selectedSwatchElems) {
          item.style.background = data.color
        }

        for (let item of this._selectedTitleElems) {
          item.innerHTML = data.title
        }

        for (let item of this._properties) {
          item.value = data[item.dataset.konvaColourChangeProperty]
        }

        if (matchMedia(`only screen and (max-width: 834px)`).matches) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }
      }
    })

  }
}